import type { SliceSettings } from './types';

export interface Template {
  id: string;
  nameKey: string;       // i18n key under "tpl."
  description: string;   // Turkish — short
  settings: Partial<SliceSettings>;
}

/** Built-in setting presets. Apply with `Object.assign(state.settings, template.settings)`. */
export const BUILTIN_TEMPLATES: Template[] = [
  {
    id: 'quick-clay',
    nameKey: 'tpl.quickClay',
    description: 'Hızlı baskı — kalın katman, hızlı hareket. Test ve prototip için.',
    settings: {
      layerHeight: 1.5,
      firstLayerHeight: 1.8,
      printSpeed: 2400,
      firstLayerSpeed: 1200,
      travelSpeed: 4000,
      vaseMode: true,
      perimeters: 1,
      bottomLayers: 2,
      topLayers: 0,
      infillDensity: 0,
      infillPattern: 'none',
      infillAngle: 45
    }
  },
  {
    id: 'detailed',
    nameKey: 'tpl.detailed',
    description: 'İnce detay — düşük katman, yavaş baskı. Süslü vazolar için.',
    settings: {
      layerHeight: 0.8,
      firstLayerHeight: 1.0,
      printSpeed: 900,
      firstLayerSpeed: 500,
      travelSpeed: 2400,
      vaseMode: true,
      perimeters: 1,
      bottomLayers: 3,
      topLayers: 0,
      infillDensity: 0,
      infillPattern: 'none',
      infillAngle: 45
    }
  },
  {
    id: 'large-print',
    nameKey: 'tpl.large',
    description: 'Büyük baskı — çok kalın katman, düşük hız. Kase ve sürahi için.',
    settings: {
      layerHeight: 2.5,
      firstLayerHeight: 3.0,
      printSpeed: 1200,
      firstLayerSpeed: 700,
      travelSpeed: 3000,
      vaseMode: true,
      perimeters: 1,
      bottomLayers: 2,
      topLayers: 0,
      infillDensity: 0,
      infillPattern: 'none',
      infillAngle: 45
    }
  },
  {
    id: 'solid-layered',
    nameKey: 'tpl.solid',
    description: 'Dolu duvarlı — vazo modu kapalı, çoklu çevre + dolgu.',
    settings: {
      layerHeight: 1.0,
      firstLayerHeight: 1.2,
      printSpeed: 1500,
      firstLayerSpeed: 800,
      travelSpeed: 3000,
      vaseMode: false,
      perimeters: 2,
      bottomLayers: 3,
      topLayers: 3,
      infillDensity: 0.2,
      infillPattern: 'lines',
      infillAngle: 45
    }
  }
];
